import { Component, ChangeDetectionStrategy, EventEmitter, Output, Input } from '@angular/core';
import { MotesLoginService, LoginState } from './motes-login.service';
import { ViewEncapsulation } from '@angular/core';

@Component({
    selector: "motes-login-overlay",
    templateUrl: './motes-login-overlay.component.html',
    styleUrls: ['./motes-login.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default
})
export class MotesLoginComponentOverlay {
    @Output() viewLoaded: EventEmitter<void> = new EventEmitter();

    @Input() hideOnClickOutside: boolean = true;
    @Input() language: 'en' | 'da' = 'en';
    @Output() closeMe: EventEmitter<boolean> = new EventEmitter();

    constructor(public loginService: MotesLoginService) {
    }

    public overlayClick() {
        // Dont close on clidk outside if this option is chosen
        // however, just in case some state fucks up allow close if login is done
        if(this.hideOnClickOutside || this.loginService.loginOverlayState == LoginState.SIGN_IN_DONE) this.loginService.showLoginOverlay = false;
    }
}
